import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './index.module.scss';
import Button from 'components/Button';

import { allResponderAndSupervisor, getDistributionOptions } from './helper';

import AssignPersonnelAsync from './assignPersonnelAsync';
import SetDistribution from './setDistribution';
import MakeEventInappropriate from './eventInappropriate';
import EventPopupForm from './inappropriatePopupForm';
import InputLabel from '@material-ui/core/InputLabel';
import PublishEvent from './publishEvent';
import ViewPublishedEvent from './viewPublished';
import ApproveOrRejectEvent from './approveOrRejectEvent';
import { t } from 'i18next';
import { eventsPageActions } from 'containers/Pages/Events';
import API from 'services/api';
import { ROLES } from 'utils/constants';
import uniqBy from 'lodash/uniqBy';
import {
  getSecurityCompanyId,
  getSecurityCompanyRoles,
  getSecurityCompanyServices,
} from 'reducers/securityCompany';

const OperationalComponent = ({
  event,
  assignEventToPersonnel,
  loggedInUser,
  updateDistribution,
  rawEventsData,
  submitEventForReview,
  setInappropriate,
  qualifiedToSubmitReview,
  qualifiedToReview,
  qualifiedToDistributeAndAssign,
  isQualifiedToPublish,
  securityCompanyId,
  availableRoles,
  availableServices,
}) => {
  // maintain userList
  const [eventAssigneeList, setEventAssigneeList] = useState([]);

  const onClickAssignEventToPersonnel = selectedEventAssignee => {
    const selectedAssignee = eventAssigneeList.find(
      assignee => assignee.general.id === selectedEventAssignee.id,
    );
    assignEventToPersonnel(event.others.id.value, selectedAssignee.general);
  };

  const onClickChangeDistribution = selectedDistribution => {
    updateDistribution(event.others.id.value, selectedDistribution.id);
  };

  const onClickSubmitForReview = () => {
    const selectedEvent = rawEventsData.find(
      data => data.general.id === event.others.id.value,
    );
    submitEventForReview(selectedEvent);
  };

  const setEventInappropriate = ({ reason, description }) => {
    setInappropriate({
      eventId: event.others.id.value,
      reason,
      description,
    });
  };

  const viewPublished = () => {
    if (event.others.publishing.value.publishedId) {
      return (
        event.others.id.value !== event.others.publishing.value.publishedId
      );
    } else {
      return false;
    }
  };
  // const onMsg = () => {
  //   toggleModal();
  //   toggleEditMode();
  //   setMessage();
  // };

  const payload = {
    securityCompanyId,
    roles: [...availableRoles, ROLES.SECURITY_COMPANY_MANAGER.id],
    archived: false,
    status: undefined,
  };

  const distributionOptions = getDistributionOptions(
    loggedInUser.roles,
    event.generalInfo.eventCategory.value,
    availableServices,
  );
  return (
    <div className={styles.operationalPanel}>
      {qualifiedToDistributeAndAssign && (
        <AssignPersonnelAsync
          assignHandler={onClickAssignEventToPersonnel}
          event={event}
          fetchOptions={API.fetchUserList}
          dataTransform={({ data }) => {
            setEventAssigneeList(prev =>
              uniqBy([...prev, ...data], 'general.id'),
            );
            return allResponderAndSupervisor(data);
          }}
          fetchFilters={payload}
          optionLabelKey={'label'} // allResponderAndSupervisor returns list of [{id:'', label:''}], hince optionKey should be label
        />
      )}
      {qualifiedToDistributeAndAssign && (
        <SetDistribution
          user={loggedInUser}
          event={event}
          setDistributionHandler={onClickChangeDistribution}
          options={distributionOptions}
        />
      )}
      <MakeEventInappropriate
        popupTitle={'Event Inappropriate'}
        PopupForm={EventPopupForm}
        popupFormSubmitHandler={setEventInappropriate}
      />

      <div className={cn(styles.operationalView, styles.btnWithLabel)}>
        <InputLabel>{t('Publish')}:</InputLabel>
        <div>
          {isQualifiedToPublish && <PublishEvent id={event.others.id.value} />}
          {viewPublished() && (
            <ViewPublishedEvent
              id={event.others.publishing.value.publishedId}
            />
          )}
        </div>
      </div>

      {qualifiedToSubmitReview && (
        <div className={cn(styles.operationalView, styles.singleBtn)}>
          <Button
            text="SUBMIT FOR REVIEW"
            size="l"
            onClick={onClickSubmitForReview}
          />
        </div>
      )}

      {qualifiedToReview && (
        <ApproveOrRejectEvent
          eventId={event.others.id.value}
          approver={loggedInUser}
          status={event.others.publishing.value.currentStatus}
        />
      )}
    </div>
  );
};
const mapStateToProps = state => ({
  loggedInUser: state.user.general,
  securityCompanyId: getSecurityCompanyId(state),
  availableRoles: getSecurityCompanyRoles(state),
  availableServices: getSecurityCompanyServices(state),
});

const mapDispatchToProps = dispatch => ({
  assignEventToPersonnel: (id, selectedAssignee) =>
    dispatch(
      eventsPageActions.assignEventToPersonnel({ id, selectedAssignee }),
    ),
  updateDistribution: (id, distribution) =>
    dispatch(eventsPageActions.updateDistribution({ id, distribution })),
  submitEventForReview: event =>
    dispatch(eventsPageActions.submitEventForReview(event)),
  setInappropriate: ({ eventId, reason, description }) =>
    dispatch(
      eventsPageActions.setInappropriate({ eventId, reason, description }),
    ),
});
OperationalComponent.propTypes = {
  event: PropTypes.object,
  assignEventToPersonnel: PropTypes.func,
  loggedInUser: PropTypes.object,
  updateDistribution: PropTypes.func,
  rawEventsData: PropTypes.object,
  submitEventForReview: PropTypes.func,
  setInappropriate: PropTypes.func,
  qualifiedToSubmitReview: PropTypes.bool,
  qualifiedToReview: PropTypes.bool,
  isQualifiedToPublish: PropTypes.bool,
  qualifiedToDistributeAndAssign: PropTypes.bool,
  setMessage: PropTypes.func,
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  availableServices: PropTypes.array,
  securityCompanyId: PropTypes.string,
  availableRoles: PropTypes.array,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperationalComponent);
